import { createActions } from 'redux-actions';

export const {
  walkthroughAddCode,
  walkthroughRemoveCode,
  walkthroughInProgress,
  walkthroughOutProgress,
  walkthroughWithChartProgress,
  walkthroughWithoutChartProgress,
  cleanWalkthrough,
  toggleMonacoInit,
} = createActions(
  'WALKTHROUGH_ADD_CODE',
  'WALKTHROUGH_REMOVE_CODE',
  'WALKTHROUGH_IN_PROGRESS',
  'WALKTHROUGH_OUT_PROGRESS',
  'WALKTHROUGH_WITH_CHART_PROGRESS',
  'WALKTHROUGH_WITHOUT_CHART_PROGRESS',
  'CLEAN_WALKTHROUGH',
  'TOGGLE_MONACO_INIT'
);
